import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getData } from "../../api";
import { isBiro, indikator_color } from "../../utils/helper";
import HeaderComp from "./components/HeaderComp";
import FormFilterDashboard from "./../Dashboard/FormFilterDashboard";
import FormFilterIndikator from "./FormFilterIndikator";
import { change_var_filter } from '../../config/redux/action';
import { toast } from "react-toastify";
import API from "./../../utils/API";
import moment from "moment-timezone";


const IndikatorKesehatan = () => {
  const dispatch = useDispatch();
  const filter = useSelector((state) => state.main);
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const [data, setData] = useState([]);
  const [dataAspekOperasional, setDataAspekOperasional] = useState([]);
  const [dataAspekAdministrasi, setDataAspekAdministrasi] = useState([]);
  const [dataTingkatKesehatan, setDataTingkatKesehatan] = useState([]);
  const [firstShow, setfirstShow] = useState(true);
  const { year, kuartal, company, companyName, reportType, } = useSelector(
    (state) => state.documentReportReducer
  );

  const chartFilterDashboard = useSelector(
    (state) => state.chartFilterDashboard
  );


  const month = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];

  const loadData = async (startYear, endYear, type, startMonth, endMonth, perusahaanId) => {
    try {
      if (chartFilterDashboard.jenis == 'laporan_bulanan') {
        var tahun = moment().format("YYYY");
        var bulan = moment().format("M");
        if (endMonth == 0 || endMonth == '' || endMonth == null) { } else {
          bulan = endMonth
        }
        if ((startYear == tahun)) {
          tahun = moment().format("YYYY");
        } else {
          tahun = startYear
        }
        var tingkatKesehatan = await getData(tahun, tahun, type, bulan, bulan, perusahaanId, 'tingkat-kesehatan');
        setDataTingkatKesehatan(tingkatKesehatan.data)
      } else {
        const res = await getData(startYear, endYear, type, startMonth, endMonth, perusahaanId, 'aspek-keuangan');
        const aspekOperasional = await getData(startYear, endYear, type, startMonth, endMonth, perusahaanId, 'aspek-operasional');
        const aspekAdministrasi = await getData(startYear, endYear, type, startMonth, endMonth, perusahaanId, 'aspek-administrasi');
        var tingkatKesehatan = await getData(startYear, endYear, type, startMonth, endMonth, perusahaanId, 'tingkat-kesehatan');
        setData(res.data);
        setDataAspekOperasional(aspekOperasional.data)
        setDataAspekAdministrasi(aspekAdministrasi.data)
        setDataTingkatKesehatan(tingkatKesehatan.data)
      }
    } catch (err) { }
  };

  useEffect(() => {
    if (chartFilterDashboard.bumd !== undefined && isBiro()) {
      loadData(chartFilterDashboard.startYear, chartFilterDashboard.endYear, chartFilterDashboard.type, chartFilterDashboard.startMonth, chartFilterDashboard.endMonth, chartFilterDashboard.bumd);
    } else {
      loadData(chartFilterDashboard.startYear, chartFilterDashboard.endYear, chartFilterDashboard.type, chartFilterDashboard.startMonth, chartFilterDashboard.endMonth, user.perusahaan.id);
    }
  }, [chartFilterDashboard]);


  useEffect(() => {
    return () => {
      dispatch(change_var_filter({ prop: "bumd", value: '' }));
    };
  }, []);

  const renderViewTahunan = () => {
    return (
      <>
        <div className="container mt-3">
          <div className="card container shadow-sm border-0 ">
            <div className="row">
              <div className="col py-3">
                <h1>Aspek Keuangan</h1>
                <table className="table table-stripped">
                  <thead>
                    <tr>
                      {data.slice(0, 1).map((d, i) => (
                        <th className="col-2">{d.perusahaanName}</th>
                      ))}
                      {/* <th>Tahun</th> */}
                      {/* <th>Hasil</th> */}
                      <th>Skor</th>
                      <th>Keterangan</th>
                    </tr>
                  </thead>

                  <tbody>
                    {data?.map((d, i) => (
                      <tr>
                        {/* <td>{d.perusahaanName}</td> */}
                        <td>{d.year ?? "-"}</td>
                        {/* <td>{d["aspekKeuangan"]?.skor ?? "-"}</td> */}
                        <td>{d["aspekKeuangan"]?.hasil ?? "-"}</td>
                        <td>{d["aspekKeuangan"]?.keterangan ?? "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <hr />
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-3">
          <div className="card container shadow-sm border-0 ">
            <div className="row">
              <div className="col py-3">
                <h1>Aspek Operasional</h1>
                <table className="table table-stripped">
                  <thead>
                    <tr>
                      {data.slice(0, 1).map((d, i) => (
                        <th className="col-2">{d.perusahaanName}</th>
                      ))}
                      {/* <th>Tahun</th> */}
                      {/* <th>Hasil</th> */}
                      <th>Skor</th>
                      <th>Keterangan</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataAspekOperasional?.map((d, i) => (
                      <tr>
                        {/* <td>{d.perusahaanName}</td> */}
                        <td>{d.year ?? "-"}</td>
                        {/* <td>{d["aspekOperasional"]?.skor ?? "-"}</td> */}
                        <td>{d["aspekOperasional"]?.hasil ?? "-"}</td>
                        <td>{d["aspekOperasional"]?.keterangan ?? "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <hr />
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-3">
          <div className="card container shadow-sm border-0 ">
            <div className="row">
              <div className="col py-3">
                <h1>Aspek Administrasi</h1>
                <table className="table table-stripped">
                  <thead>
                    <tr>
                      {data.slice(0, 1).map((d, i) => (
                        <th className="col-2">{d.perusahaanName}</th>
                      ))}
                      {/* <th>Tahun</th> */}
                      {/* <th>Hasil</th> */}
                      <th>Skor</th>
                      <th>Keterangan</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataAspekAdministrasi?.map((d, i) => (
                      <tr>
                        {/* <td>{d.perusahaanName}</td> */}
                        <td>{d.year ?? "-"}</td>
                        {/* <td>{d["value"]?.skor ?? "-"}</td> */}
                        <td>{d["value"]?.hasil ?? "-"}</td>
                        <td>{d["value"]?.keterangan ?? "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <hr />
              </div>
            </div>
          </div>
        </div>

        <div className="container mt-3">
          <div className="card container shadow-sm border-0 ">
            <div className="row">
              <div className="col py-3">
                <h1>Tingkat Kesehatan</h1>
                <table className="table table-stripped">
                  <thead>
                    <tr>
                      {data.slice(0, 1).map((d, i) => (
                        <th className="col-2">{d.perusahaanName}</th>
                      ))}
                      {/* <th>Tahun</th> */}
                      <th>Skor Akhir</th>
                      <th>Kriteria</th>

                    </tr>
                  </thead>
                  <tbody>
                    {dataTingkatKesehatan?.map((d, i) => (
                      <tr>
                        {/* <td>{d.perusahaanName}</td> */}
                        <td>{d.year ?? "-"}</td>
                        <td>{d.skor}</td>
                        <td><div style={{ display: 'inline', backgroundColor: indikator_color(d.kriteria), padding: 5, borderRadius: 5 }}><span style={{ fontWeight: 'bold', color: 'white' }} className="center">{d.kriteria}</span></div></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }


  const renderViewBulanan = () => {
    return (
      <>
        <div className="container mt-3">
          <div className="card container shadow-sm border-0 ">
            <div className="row">
              <div className="col py-3">
                <h1>Tingkat Kesehatan</h1>
                <table className="table table-stripped">
                  <thead>
                    <tr>
                      <th className="col-2">Bulan</th>
                      <th>Aspek Keuangan</th>
                      <th>Aspek Operasional</th>
                      <th>Aspek Administrasi</th>
                      <th>Skor</th>
                      <th>Indikator Kesehatan</th>

                    </tr>
                  </thead>
                  <tbody>
                    {dataTingkatKesehatan?.map((d, i) => (
                      <tr>
                        <td>{d.month}</td>
                        <td>{d.skorAspekKeuangan}</td>
                        <td>{d.skorAspekOperasional}</td>
                        <td>{d.skorAspekAdministrasi}</td>
                        <td>{d.skor}</td>
                        <td><div style={{ display: 'inline', backgroundColor: indikator_color(d.kriteria), padding: 5, borderRadius: 5 }}><span style={{ fontWeight: 'bold', color: 'white' }} className="center">{d.kriteria}</span></div></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <FormFilterIndikator />
      {chartFilterDashboard.jenis == 'laporan_bulanan' ? renderViewBulanan() : renderViewTahunan()}
    </>
  );
};

export default IndikatorKesehatan;
